export const URL_TEMPLATES = {
    APP: "/app",
    _404: "/app/404",
    LOGIN: "/app/login",
    PASSWORD_FORGOT: "/app/password/forgot",
    PASSWORD_RESET: "/app/password/reset",
    SSO: "/app/sso",
    ACCOUNT: "/app/account",
    TENANT: "/app/tenant",
    TENANT_LIST: "/app/tenant/:tenantId/tenant",
    CREATE_TENANT: "/app/tenant/:tenantId/tenant/create",
    EDIT_TENANT: "/app/tenant/:tenantId/edit",
    USER_LIST: "/app/tenant/:tenantId/user",
    CREATE_USER: "/app/tenant/:tenantId/user/create",
    USER: "/app/user",
    EDIT_USER: "/app/user/:userId/edit",
    ORDER: "/app/order",
    EDIT_ORDER_TENANT: "/app/order/:orderId/tenant/edit",
    ORDER_LIST: "/app/order?tenantId=:tenantId",
    ORDER_DETAIL: "/app/order/:orderId",
    REQUEST_CERTIFICATE: "/app/order/:orderId/request",
    REISSUE_CERTIFICATE: "/app/order/:orderId/reissue",
    RENEW_CERTIFICATE: "/app/order/:orderId/renew",

    ORGANISATION: "/app/organisation",
    ORGANISATION_LIST: "/app/organisation?tenantId=:tenantId",
    ORGANISATION_DETAIL: "/app/organisation/:tenantId/detail/:organizationId",
    CREATE_ORGANISATION: "/app/organisation/:tenantId/create",
    RENEW_ORGANISATION: "/app/organisation/:tenantId/renew/:orderId"
};
